import SettingPage from 'pages/setting/page'

export const settingsRoutes = [{ path: '/setting', element: <SettingPage /> }]
